export const listOfOptionsData = [
    // {title: "Добавить замещающего", call: "add"},
    // {title: "Удалить замещающего", call: "delete"},
    { title: "Подробная информация", call: "details" },
];
